export type CustomActionBaseEvent = typeof CUSTOM_ACTION_BASE_EVENT;

export const CUSTOM_ACTION_BASE_EVENT = `custom:action`;

export const CUSTOM_ACTION_EVENT = <const>{
	UPDATED: `${CUSTOM_ACTION_BASE_EVENT}:updated`,
};
